import { render, staticRenderFns } from "./taoTe.vue?vue&type=template&id=d4a6aa98&"
import script from "./taoTe.vue?vue&type=script&lang=js&"
export * from "./taoTe.vue?vue&type=script&lang=js&"
import style0 from "./taoTe.vue?vue&type=style&index=0&id=d4a6aa98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports